 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import HTML00_COVER_PA from '@/components/html/00_Cover_Pa'
 import HTML01_FMT from '@/components/html/01_Fmt'
 import HTML02_TITLE_PA from '@/components/html/02_Title_Pa'
 import HTML03_COPYRIGH from '@/components/html/03_Copyrigh'
 import HTML04_DEDICATI from '@/components/html/04_Dedicati'
 import HTML05_CONTENTS from '@/components/html/05_Contents'
 import HTML06_ACKNOWLE from '@/components/html/06_Acknowle'
 import HTML07__WRITE_T from '@/components/html/07__Write_t'
 import HTML08_1__FROM from '@/components/html/08_1__From'
 import HTML09_IT_S_HAR from '@/components/html/09_It_s_Har'
 import HTML10_FROM_OUR from '@/components/html/10_From_Our'
 import HTML11_GROWING from '@/components/html/11_Growing'
 import HTML12_EASTER_ from '@/components/html/12_Easter_'
 import HTML13_HANDS from '@/components/html/13_Hands'
 import HTML14_RIDL_WAS from '@/components/html/14_Ridl_Was'
 import HTML15_A_MIDSUM from '@/components/html/15_A_Midsum'
 import HTML16_MY_FATHE from '@/components/html/16_My_Fathe'
 import HTML17_OPEN_TO from '@/components/html/17_Open_to'
 import HTML18_THE_STEP from '@/components/html/18_The_Step'
 import HTML19_IT_WASN_ from '@/components/html/19_It_Wasn_'
 import HTML20_THINKING from '@/components/html/20_Thinking'
 import HTML21_ON_MY_PA from '@/components/html/21_On_My_Pa'
 import HTML22_AN_AFTER from '@/components/html/22_An_After'
 import HTML23_THE_DAYS from '@/components/html/23_The_Days'
 import HTML24_A_NEW_BE from '@/components/html/24_A_New_Be'
 import HTML25_THE_LETT from '@/components/html/25_The_Lett'
 import HTML26_FRACTALS from '@/components/html/26_Fractals'
 import HTML27_SEARCHIN from '@/components/html/27_Searchin'
 import HTML28_2__THE_E from '@/components/html/28_2__The_E'
 import HTML29_SUITE_FO from '@/components/html/29_Suite_Fo'
 import HTML30_ON_GOING from '@/components/html/30_On_Going'
 import HTML31_THE_ENOR from '@/components/html/31_The_Enor'
 import HTML32_THEME_AN from '@/components/html/32_Theme_an'
 import HTML33_OH_I_SUP from '@/components/html/33_Oh_I_Sup'
 import HTML34_HERE_IN from '@/components/html/34_Here_in'
 import HTML35_PRACTICI from '@/components/html/35_Practici'
 import HTML36_SOME_NOT from '@/components/html/36_Some_Not'
 import HTML37_WITH from '@/components/html/37_With'
 import HTML38_MORNING from '@/components/html/38_Morning'
 import HTML39_CHRISTMA from '@/components/html/39_Christma'
 import HTML40_THE_NEIG from '@/components/html/40_The_Neig'
 import HTML41_WILLIAM from '@/components/html/41_William'
 import HTML42_AFTER_TA from '@/components/html/42_After_Ta'
 import HTML43_JUST_BEF from '@/components/html/43_Just_Bef'
 import HTML44_MID_OCTO from '@/components/html/44_Mid_Octo'
 import HTML45_RON_HOWA from '@/components/html/45_Ron_Howa'
 import HTML46_TAKE_LOV from '@/components/html/46_Take_Lov'
 import HTML47_MY_WIFE from '@/components/html/47_My_Wife'
 import HTML48_A_QUIET from '@/components/html/48_A_Quiet'
 import HTML49_SPEAKING from '@/components/html/49_Speaking'
 import HTML50_RAKING_T from '@/components/html/50_Raking_t'
 import HTML51_PUTTING from '@/components/html/51_Putting'
 import HTML52_HARDSHIP from '@/components/html/52_Hardship'
 import HTML53_THE_END from '@/components/html/53_The_End'
 import HTML54_HAVE_YOU from '@/components/html/54_Have_You'
 import HTML55_IT_S_APR from '@/components/html/55_It_s_Apr'
 import HTML56_EPILOGUE from '@/components/html/56_Epilogue'
 import HTML57_INTERLUD from '@/components/html/57_Interlud'
 import HTML58_CIRCUS_ from '@/components/html/58_Circus_'
 import HTML59_OUTSIDE from '@/components/html/59_Outside'
 import HTML60_GROUSE_O from '@/components/html/60_Grouse_o'
 import HTML61_AFTER_TH from '@/components/html/61_After_th'
 import HTML62_SEQUINS from '@/components/html/62_Sequins'
 import HTML63_DAYDREAM from '@/components/html/63_Daydream'
 import HTML64_SUZIE from '@/components/html/64_Suzie'
 import HTML65_THE_DEAT from '@/components/html/65_The_Deat'
 import HTML66_CIRCUS_C from '@/components/html/66_Circus_C'
 import HTML67_THE_END from '@/components/html/67_The_End'
 import HTML68_DEATH_IN from '@/components/html/68_Death_in'
 import HTML69_THE_CHIL from '@/components/html/69_The_Chil'
 import HTML70_ROUSTABO from '@/components/html/70_Roustabo'
 import HTML71_CLOWN from '@/components/html/71_Clown'
 import HTML72_THE_BALL from '@/components/html/72_The_Ball'
 import HTML73_NIGHT_ON from '@/components/html/73_Night_on'
 import HTML74_WINTER_Q from '@/components/html/74_Winter_Q'
 import HTML75_3__THE_H from '@/components/html/75_3__The_H'
 import HTML76_THE_TWO from '@/components/html/76_The_Two'
 import HTML77_WHAT_ARE from '@/components/html/77_What_Are'
 import HTML78_WITHIN_T from '@/components/html/78_Within_t'
 import HTML79_THE_HIDD from '@/components/html/79_The_Hidd'
 import HTML80_LISTENIN from '@/components/html/80_Listenin'
 import HTML81_AT_THE__ from '@/components/html/81_At_the__'
 import HTML82_INSTEAD from '@/components/html/82_Instead'
 import HTML83_THE_MAN from '@/components/html/83_The_Man'
 import HTML84_AFTER_MI from '@/components/html/84_After_Mi'
 import HTML85_A_MAN_I from '@/components/html/85_A_Man_I'
 import HTML86__MOOSE_ from '@/components/html/86__Moose_'
 import HTML87_SEVERAL from '@/components/html/87_Several'
 import HTML88_A_LIST_O from '@/components/html/88_A_List_o'
 import HTML89_HE_BRING from '@/components/html/89_He_Bring'
 import HTML90_MONET_S from '@/components/html/90_Monet_s'
 import HTML91_PRELUDES from '@/components/html/91_Preludes'
 import HTML92_ANOTHER from '@/components/html/92_Another'
 import HTML93_THE_REUN from '@/components/html/93_The_Reun'
 import HTML94_THE_DOGS from '@/components/html/94_The_Dogs'
 import HTML95_THE_ARTI from '@/components/html/95_The_Arti'
 import HTML96_A_CHRIST from '@/components/html/96_A_Christ'
 import HTML97_BUT_HE_L from '@/components/html/97_But_He_L'
 import HTML98_A_CABINE from '@/components/html/98_A_Cabine'
 import HTML99_THE_YEAR from '@/components/html/99_The_Year'
 import HTML100_ANOTHER from '@/components/html/100_Another'
 import HTML101_THE_KNIT from '@/components/html/101_The_Knit'
 import HTML102_DRINKING from '@/components/html/102_Drinking'
 import HTML103_FOR_LENN from '@/components/html/103_For_Lenn'
 import HTML104_A_GENERO from '@/components/html/104_A_Genero'
 import HTML105_AFTER_SP from '@/components/html/105_After_Sp'
 import HTML106_RETURN_T from '@/components/html/106_Return_t'
 import HTML107_THE_HERO from '@/components/html/107_The_Hero'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/html/05_Contents",
 			"name" : "html/05_Contents",
 			"component" : HTML05_CONTENTS
 		},
 		{
 			"path" : "/html/06_Acknowle",
 			"name" : "html/06_Acknowle",
 			"component" : HTML06_ACKNOWLE
 		},
 		{
 			"path" : "/html/07__Write_t",
 			"name" : "html/07__Write_t",
 			"component" : HTML07__WRITE_T
 		},
 		{
 			"path" : "/html/08_1__From",
 			"name" : "html/08_1__From",
 			"component" : HTML08_1__FROM
 		},
 		{
 			"path" : "/html/09_It_s_Har",
 			"name" : "html/09_It_s_Har",
 			"component" : HTML09_IT_S_HAR
 		},
 		{
 			"path" : "/html/10_From_Our",
 			"name" : "html/10_From_Our",
 			"component" : HTML10_FROM_OUR
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js